import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

import * as FaIcons from "react-icons/fa";

const headers = [
  { name: "action", display: "Select" },
  { name: "orientationTime", display: "Orientation Date" },
  // { name: "orientationTime", display: "Time" },
  { name: "status", display: "Status" },
  { name: "learningCenterName", display: "Learning Center" },
  { name: "registerForIntercession", display: "Enrollment" },
  { name: "firstName", display: "Student Name" },
  { name: "age", display: "Age" },
  { name: "programs", display: "Programs" },
  { name: "moreInfo", display: "View Details" },
];

const RegistrationFormRow = ({
  info,
  setItems,
  selectedItems,
}) => {
  const location = useLocation();
  const {
    _id,
    createdAt,
    status,
    registerForIntercession,
    age,
    firstName,
    lastName,
    studentEmail,
    studentPrimaryPhone,
    learningCenterName,
    programs,
    orientationType,
    orientationTime,
  } = info;

  const handleSelection = () => {
    if (!selectedItems.includes(info)) {
      setItems([...selectedItems, info]);
    } else {
      setItems(selectedItems.filter((item) => item._id !== info._id));
    }
  };
  const isVirtual = orientationType === "VIRTUAL";
	const timeParts = (orientationTime || " - ").split(" - ");
  return (
    <tr
      style={{
        backgroundColor: selectedItems.includes(info)
          ? "rgba(137, 177, 81, 0.4)"
          : "",
      }}
    >
      <td className="checkbox-td">
        <input
          type="checkbox"
          checked={selectedItems.includes(info)}
          onClick={handleSelection}
          onChange={handleSelection}
        />
      </td>
      <td>{isVirtual ? "Virtual" : timeParts[0]}</td>
      {/* <td>
        {isVirtual
          ? "N/A"
          : `${orientationTime.split(" - ")[1]} - ${
              orientationTime.split(" - ")[2]
            } `}
      </td> */}
      <td>{status}</td>
      <td>{learningCenterName}</td>
      <td>{registerForIntercession ? "Intersession " : "Regular"}</td>
      <td>{`${firstName} ${lastName}`}</td>
      <td>{age}</td>
      <td>
        {programs && programs.el && (
          <div className="programs-status">
            {Object.keys(programs).map((item) => {
              return (
                <div className="item">
                  <p>{item === "fiveZeroFour" ? "504" : item.toUpperCase()}</p>
                  <div className="circle">
                    {programs[item].unchecked ? null : programs[item].true ? (
                      <FaIcons.FaCheck className="program-icon" />
                    ) : (
                      <FaIcons.FaTimes className="program-icon" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </td>
      <td>
        <Link
          to={{
            pathname: `/registration-forms/${_id}`,
            state: { from: location.pathname },
          }}
          className="btn btn-llac-dark-green"
        >
          View
        </Link>
      </td>
    </tr>
  );
};

const TableHeaderItem = ({ name, display }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { orientationSortOptions, onOrientationTableFilter } =
    adminRegistrationContext;

  return (
    <th onClick={() => onOrientationTableFilter(name)}>
      <div className="wrap">
        <span>{display}</span>
        <div className="filter">
          <FaIcons.FaSortUp
            style={{
              color: orientationSortOptions[name].asc ? "#343434" : "white",
            }}
          />
          <FaIcons.FaSortDown
            style={{
              color: orientationSortOptions[name].desc ? "#343434" : "white",
            }}
          />
        </div>
      </div>
    </th>
  );
};

const RegistrationTable = ({ items }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { handleBatchStatusUpdate } = adminRegistrationContext;
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSubmit = () => {
    if (selectedItems.length > 0) handleBatchStatusUpdate({ selectedItems });
  };

  const handleToggleSelect = () => {
    if (selectedItems.length === items.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(items);
    }
  };

  return (
    <div className="interest-form-table">
      <div className="submit-box">
        <div className="btn btn-llac-dark-green" onClick={handleSubmit}>
          Set to Completed Orientation
        </div>
      </div>
      <table id="interest-table">
				<thead>
        <tr>
          {headers.map((header) => {
            const display =
              header.name === "action" ? (
                <th onClick={handleToggleSelect}>
                  <div className="wrap">
                    <input
                      type="checkbox"
                      checked={selectedItems.length === items.length}
                    />
                  </div>
                </th>
              ) : (
                <TableHeaderItem name={header.name} display={header.display} />
              );
            return display;
          })}
        </tr>
				</thead>
				<tbody>
        {items.map((item) => {
          return (
            <RegistrationFormRow
              info={item}
              setItems={setSelectedItems}
              selectedItems={selectedItems}
            />
          );
        })}
				</tbody>
      </table>
    </div>
  );
};

export default RegistrationTable;
